/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import parse from 'html-react-parser';
import { CheckboxList } from '../../../../../../UiKit';
import { debounce, toNumber } from 'lodash-es';
import { AddItemButtonCustom } from '../../../../../../UiKit/addItemButtonCustom/addItemButtonCustom';
import SubItemSelectionView from './SubItemSelectionView';
import InputV1 from '../../../../../ComponentsV1/InputV1';
import {
  IssueItemCustomRefundUpdateEvent,
  IssueItemPickupClickEvent,
  IssueItemQuantityUpdateEvent,
} from '../../../../../../analytics/raise-an-issue/events';
import { MetricsForJumboEvent } from '../../../../../../analytics/constants';
import BistroComboUI from './BistroComboUI';
import { RefreshCcw } from 'lucide-react';
import { ToolTip } from '../../../../../ComponentsV1/ToolTip/Tooltip';

export default class MultiSelectViewV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selectedItem || {},
      tempInput: this.props.selectedItem || {},
      selectedSubItems: [],
      disabled: false,
    };
    this.debouncedUpdateCustomAmount = debounce(this.updateCustomAmount, 300);
    this.deb = debounce((selected) => {
      const { selectItems } = this.props;
      selectItems(selected);
    }, 800);
  }

  counterIncrease = (item) => {
    if (!item?.id) return;
    const { selectItems, complaintType } = this.props;
    const { selected } = this.state;
    let newSelected = selected;
    if (newSelected?.[`${item.id}`]?.quantity > 0) {
      newSelected = {
        ...selected,
        [`${item.id}`]: {
          ...selected?.[`${item.id}`],
          item_id: item.id,
          quantity: selected?.[`${item.id}`]?.quantity
            ? selected[`${item.id}`]?.quantity + 1
            : 1,
          item_text: item?.text,
          item_category: item?.category_name,
          item_image_url: item?.item_image_url,
        },
      };
    } else {
      newSelected = {
        ...selected,
        [`${item.id}`]: {
          item_id: item.id,
          quantity: 1,
          pickup: item?.pickup_selected,
          custom_value: 0,
          custom_unit: item?.custom_unit,
          item_text: item?.text,
          item_category: item?.category_name,
          item_image_url: item?.item_image_url,
        },
      };
    }

    // logging the event for quantity increase
    IssueItemQuantityUpdateEvent({
      [MetricsForJumboEvent.order_id]: this.props.orderId || null,
      [MetricsForJumboEvent.customer_id]: this.props.userId || null,
      [MetricsForJumboEvent.cart_id]: this.props.cartId || null,
      [MetricsForJumboEvent.feature_meta]: {
        complaint_type: complaintType,
        change_type: 'increase',
        item_id: item?.id,
        quantity: item?.quantity,
        selected_quantity: newSelected?.[`${item?.id}`]?.quantity,
        max_quantity: item?.max_quantity,
      },
    });

    this.setState({
      selected: newSelected,
    });
    selectItems(newSelected);
  };

  counterDecrease = (item) => {
    if (!item?.id) return;
    const { selectItems, complaintType } = this.props;
    const { selected } = this.state;
    let newSelected = selected;
    if (newSelected?.[`${item.id}`]?.quantity > 1) {
      newSelected = {
        ...selected,
        [`${item.id}`]: {
          ...selected[`${item.id}`],
          item_id: item.id,
          quantity: selected[`${item.id}`]?.quantity
            ? selected[`${item.id}`]?.quantity - 1
            : 0,
          item_text: item?.text,
          item_category: item?.category_name,
          item_image_url: item?.item_image_url,
        },
      };
    } else {
      delete newSelected[`${item.id}`];
      this.setState((prevState) => ({
        tempInput: {
          ...prevState.tempInput,
          [`${item.id}`]: {
            ...prevState.tempInput[`${item.id}`],
            custom_value: 0,
            item_text: item?.text,
            item_category: item?.category_name,
            item_image_url: item?.item_image_url,
          },
        },
      }));
    }

    // logging the event for quantity decrease
    IssueItemQuantityUpdateEvent({
      [MetricsForJumboEvent.order_id]: this.props.orderId || null,
      [MetricsForJumboEvent.customer_id]: this.props.userId || null,
      [MetricsForJumboEvent.cart_id]: this.props.cartId || null,
      [MetricsForJumboEvent.feature_meta]: {
        complaint_type: complaintType,
        change_type: 'decrease',
        item_id: item.id,
        quantity: item.quantity,
        selected_quantity: newSelected?.[`${item.id}`]?.quantity ?? 0,
        max_quantity: item.max_quantity,
      },
    });

    this.setState({
      selected: newSelected,
    });
    selectItems(newSelected);
  };

  customCountHandler = (value = 0, item) => {
    const { selectItems } = this.props;
    const { selected } = this.state;
    const maxQuantity = this.getMaxQuantity(item);
    const customCount =
      value > maxQuantity
        ? maxQuantity
        : Math.max(0, Math.floor(toNumber(value)));
    let newSelected = selected;

    if (customCount)
      newSelected = {
        ...selected,
        [`${item.id}`]: {
          ...selected[`${item.id}`],
          item_id: item.id,
          quantity: customCount,
          pickup: item?.pickup_selected,
          custom_value: item?.custom_value ? item.custom_value : 0,
          custom_unit: item?.custom_unit,
        },
      };
    else {
      delete newSelected[`${item.id}`];
    }

    this.setState({
      selected: newSelected,
    });
    selectItems(newSelected);
  };

  updatePickUp = (item) => {
    if (!item?.id) return;
    const { selectItems, complaintType } = this.props;
    const { selected } = this.state;
    const itemDetails = selected[`${item.id}`];
    const updatedItemsDetails = {
      ...selected,
      [`${item.id}`]: {
        ...itemDetails,
        custom_value: selected?.[`${item.id}`]?.pickup
          ? selected?.[`${item.id}`]?.custom_value
          : 0,
        pickup: selected?.[`${item.id}`]?.pickup ? false : true,
      },
    };

    IssueItemPickupClickEvent({
      [MetricsForJumboEvent.order_id]: this.props.orderId || null,
      [MetricsForJumboEvent.customer_id]: this.props.userId || null,
      [MetricsForJumboEvent.cart_id]: this.props.cartId || null,
      [MetricsForJumboEvent.feature_meta]: {
        complaint_type: complaintType,
        item_id: item.id,
        quantity: item.quantity,
        max_quantity: item.max_quantity,
        selected_quantity: updatedItemsDetails?.[`${item.id}`]?.quantity,
        was_pickup_enabled: item.pickup_enabled,
        was_pickup_selected: item.pickup_selected,
        is_pickup_selected: updatedItemsDetails?.[`${item.id}`]?.pickup,
      },
    });

    this.setState({
      selected: updatedItemsDetails,
    });
    selectItems(updatedItemsDetails);
  };

  selectSubItems = (items) => {
    const { selectSubItems } = this.props;
    this.setState({
      selectedSubItems: items,
    });
    selectSubItems(items);
  };

  updateCustomAmount = (item, amount) => {
    if (!item?.id) return;
    const { selectItems, complaintType } = this.props;
    const { selected } = this.state;
    const itemDetails = selected[`${item.id}`];
    const maxRefund = item.custom_unit === 'absolute' ? item.max_amount : 100;
    const customValue = amount > maxRefund || amount < 0 ? maxRefund : amount;

    const updatedItemsDetails = {
      ...selected,
      [`${item.id}`]: {
        ...itemDetails,
        custom_value: customValue,
      },
    };

    IssueItemCustomRefundUpdateEvent({
      [MetricsForJumboEvent.order_id]: this.props.orderId || null,
      [MetricsForJumboEvent.customer_id]: this.props.userId || null,
      [MetricsForJumboEvent.cart_id]: this.props.cartId || null,
      [MetricsForJumboEvent.feature_meta]: {
        complaint_type: complaintType,
        item_id: item.id,
        quantity: item.quantity,
        max_quantity: item.max_quantity,
        selected_quantity: updatedItemsDetails?.[`${item.id}`]?.quantity,
        selected_custom_refund:
          updatedItemsDetails?.[`${item.id}`]?.custom_value,
      },
    });

    this.setState({
      selected: updatedItemsDetails,
    });
    selectItems(updatedItemsDetails);
  };

  isMaxLimit = (item) => {
    return this.state.selected[item.id]?.quantity === item?.max_quantity;
  };

  getMaxQuantity = (item) => {
    return this.props.capByOrderedQuantity
      ? item?.quantity
      : item?.max_quantity;
  };

  updateSelectedCards = (item, selectedCards) => {
    if (!item?.id) return;
    const { selectItems } = this.props;
    const { selected } = this.state;
    const updatedSelected = {
      ...selected,
      [`${item.id}`]: {
        ...(selected?.[`${item.id}`] || {}),
        selected_serial_numbers: selectedCards || [],
      },
    };
    this.setState({ selected: updatedSelected });
    selectItems(updatedSelected);
  };

  getMaxAmount = (item) => {
    return Math.min(
      item?.unit_cost * this.state.selected[`${item.id}`]?.quantity,
      item?.max_amount,
    );
  };

  isMaxAmount = (item, val = null) => {
    const value = val ? val : this.state.selected[item.id]?.custom_value;
    return value >
      Math.min(
        item?.unit_cost * this.state.selected[item.id]?.quantity,
        item?.max_amount,
      )
      ? true
      : false;
  };

  render() {
    const {
      items,
      customInputWidth = '100%',
      showPickupCheckbox = true,
    } = this.props;

    const { selected, disabled } = this.state;

    const pathname = window?.location?.pathname || '';

    const isIVADashboard = pathname.includes('handover');

    const hasProductHighlights = (item) => {
      return (
        item.item_highlights &&
        Array.isArray(item.item_highlights) &&
        item.item_highlights.length > 0
      );
    };

    return (
      <div className='MultiSelectView tw-w-full'>
        {items?.map((item, index) => {
          if (!item) return null;

          const { combo_composition } = item;

          let cardMinHeight = {
            minHeight: item.item_image_url ? '10rem' : '3.3rem',
          };

          const itemSelectedSubItems = (
            this.props.selectedSubItemList || []
          ).filter((subItem) => subItem?.parent_item_id === item.id);

          return (
            <>
              <div
                className='item itemInV2 tw-w-full tw-flex tw-justify-between'
                key={item.text + index}
                style={cardMinHeight}
              >
                {/* Item Details */}
                <div className='tw-flex-col tw-min-w-0 tw-flex-1'>
                  {/* Tags, Name, Category, Image and qty selector */}
                  <div
                    className={`tw-flex tw-min-w-0 ${
                      hasProductHighlights(item) ? '' : 'tw-min-h-40'
                    }`}
                  >
                    <div className='tw-flex tw-flex-col tw-w-full tw-overflow-hidden tw-min-w-0 tw-gap-[0.5rem]'>
                      {/* Item Tags */}
                      {item.tags?.length > 0 && (
                        <div className='tw-flex tw-gap-2 tw-flex-wrap'>
                          {item.tags.map((tag) => (
                            <div
                              className='tw-border-solid tw-font-regular tw-border-teal-200/30 tw-border-[1px] tw-rounded-md tw-px-2 tw-py-[0.4rem] tw-whitespace-nowrap tw-leading-none tw-w-fit tw-text-[1.1rem]'
                              key={tag.slug}
                              style={{
                                backgroundColor: tag.bg_color,
                                color: tag.color,
                              }}
                            >
                              {tag.label}
                            </div>
                          ))}
                        </div>
                      )}
                      {/* Name Text */}
                      <div className='tw-font-medium tw-text-[1.4rem] tw-leading-tight tw-text-zinc-700 tw-mr-3'>
                        {parse(item.text)}
                      </div>

                      {/* Category */}
                      {item.category_name && (
                        <ToolTip
                          content={
                            <div className='tw-font-medium tw-text-[1.2rem] tw-leading-tight tw-text-white'>
                              {item.category_name}
                            </div>
                          }
                          placement='bottom'
                        >
                          <p className='tw-font-regular tw-text-[1.2rem] tw-leading-tight tw-text-orange-600 tw-block tw-truncate tw-mr-2'>
                            In {item.category_name}
                          </p>
                        </ToolTip>
                      )}

                      {/* Description */}
                      {item.description && (
                        <p className='tw-font-medium tw-text-[1.3rem] tw-leading-tight'>
                          {item.description}
                        </p>
                      )}
                    </div>

                    {/* Item Image and Quantity Selector */}
                    <div className='tw-relative tw-flex tw-flex-col tw-items-center tw-gap-0'>
                      {item.item_image_url && (
                        <div className='tw-w-[10rem] tw-h-[9rem] tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-grey-200/50 tw-bg-grey-100/80'>
                          <img
                            src={item.item_image_url}
                            alt='item_image'
                            className='tw-object-cover'
                          />
                        </div>
                      )}
                      <div className={'tw-absolute tw-top-28'}>
                        <AddItemButtonCustom
                          count={
                            selected[item.id]?.quantity
                              ? selected[item.id]?.quantity
                              : 0
                          }
                          showCustomInput={this.getMaxQuantity(item) > 20}
                          handleIncrease={this.counterIncrease.bind(this, item)}
                          handleDecrease={this.counterDecrease.bind(this, item)}
                          setCount={(val) => {
                            this.customCountHandler(val, item);
                          }}
                          disabled={
                            disabled ||
                            item?.disabled ||
                            this.getMaxQuantity(item) === 0
                          }
                          increaseDisabled={
                            selected[item.id]?.quantity >=
                            this.getMaxQuantity(item)
                          }
                        />
                      </div>
                    </div>
                  </div>

                  {/* Product highlights */}
                  {hasProductHighlights(item) && (
                    <div className='tw-flex tw-items-center tw-flex-wrap tw-gap-2 tw-mt-10'>
                      {item.item_highlights.map((highlight) => {
                        if (!Object.entries(highlight || {}).length > 0)
                          return null;
                        const [key, value] = Object.entries(highlight)[0];
                        return (
                          <div
                            key={key}
                            className='tw-flex tw-flex-col tw-border-solid tw-rounded-lg tw-overflow-hidden tw-leading-none tw-border-zinc-200 tw-border-[0.1rem]'
                          >
                            <div className='tw-bg-zinc-100 tw-p-[0.4rem] tw-font-medium tw-text-[1.2rem] tw-text-zinc-800'>
                              {key}
                            </div>
                            <div className='tw-p-[0.4rem] tw-font-regular tw-text-[1.1rem] tw-text-zinc-600'>
                              {value}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                  {/* Cost & Inventory */}
                  {item.unit_cost_text ? (
                    <p
                      className={`${
                        hasProductHighlights(item) || item.tags?.length > 0
                          ? isIVADashboard
                            ? 'tw-mt-7'
                            : 'tw-mt-3'
                          : 'tw-mt-8'
                      } tw-w-full tw-leading-none tw-flex tw-items-center tw-justify-between`}
                    >
                      <div className='tw-font-medium tw-text-[1.3rem] tw-mt-1'>
                        {item.quantity !== null || item.quantity !== undefined
                          ? `${item.quantity} x`
                          : ''}{' '}
                        {item.unit_cost_text}
                      </div>
                      <div
                        className={`tw-font-medium tw-text-[1.3rem] tw-mt-1 ${
                          item.inventory === 0 ? 'tw-text-red-600' : ''
                        }`}
                      >
                        {item.inventory !== null && item.inventory !== undefined
                          ? item.inventory === 0
                            ? 'Out of stock'
                            : `Inventory: ${item.inventory}`
                          : ''}
                      </div>
                    </p>
                  ) : null}
                  {/* Substitutes available */}
                  {item?.substitutes_available ? (
                    <span
                      className={
                        'tw-text-[1.2rem] tw-mt-3 tw-font-medium tw-leading-none tw-text-base-green tw-flex tw-items-center tw-gap-2'
                      }
                    >
                      <RefreshCcw size={13} />
                      Substitute(s) available for this item
                    </span>
                  ) : null}
                  {/* Pickup and Refund UI */}
                  <div className='tw-flex tw-flex-col tw-w-full'>
                    {/* Checkbox and Refund Input */}
                    {selected?.[`${item.id}`]?.quantity > 0 &&
                      showPickupCheckbox && (
                        <div className='tw-mt-4 tw-flex tw-flex-col'>
                          {/* Pickup */}
                          {(item?.pickup_enabled || item?.pickup_selected) && (
                            <CheckboxList
                              items={[
                                {
                                  text: 'Pickup',
                                  selected:
                                    item?.quantity > 0
                                      ? selected[item.id].pickup
                                      : item?.pickup_selected,
                                },
                              ]}
                              alreadyChecked={
                                item?.pickup_selected ? ['pickup'] : []
                              }
                              selectOptions={() => {
                                this.updatePickUp(item);
                              }}
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'wrap',
                                margin: 0,
                                fontWeight: 500,
                              }}
                              disabled={!item?.pickup_enabled}
                            />
                          )}

                          <div
                            className={'tw-flex tw-items-center tw-gap-8'}
                            style={{
                              maxHeight: !selected[`${item.id}`]?.pickup
                                ? '50rem'
                                : '0',
                              opacity: !selected[`${item.id}`]?.pickup ? 1 : 0,
                              transform: !selected[`${item.id}`]?.pickup
                                ? 'translateY(0)'
                                : 'translateY(-10px)',
                              transition: 'all 0.3s cubic-bezier(0.4,0,0.2,1)',
                              overflow: 'hidden',
                            }}
                          >
                            <div
                              className={
                                'tw-flex tw-flex-col tw-gap-3 tw-w-full'
                              }
                              style={{
                                width: customInputWidth
                                  ? customInputWidth
                                  : '100%',
                              }}
                            >
                              <div
                                className={
                                  'tw-border tw-border-solid tw-border-grey-200 tw-rounded-lg tw-flex tw-justify-end focus-within:tw-border-base-green'
                                }
                              >
                                <div className='tw-whitespace-nowrap tw-flex tw-items-center tw-ml-3 tw-mr-1'>
                                  {item?.custom_unit == 'absolute' ? (
                                    <span className='tw-text-[1.3rem] tw-font-medium tw-leading-none tw-text-zinc-600'>
                                      Refund Amt:
                                    </span>
                                  ) : (
                                    <span className='tw-text-[1.3rem] tw-font-medium tw-leading-none tw-text-zinc-600'>
                                      Refund % :
                                    </span>
                                  )}
                                </div>
                                {/* input field */}
                                <input
                                  id={`input_${item.id}`}
                                  type='number'
                                  onInput={(e) => {
                                    const maxRefund =
                                      item.custom_unit === 'absolute'
                                        ? Math.min(
                                            item.max_amount,
                                            item.unit_cost *
                                              (selected[item.id]?.quantity ||
                                                0),
                                          )
                                        : 100;
                                    if (e.target.value > maxRefund)
                                      document.getElementById(
                                        `input_${item.id}`,
                                      ).value = maxRefund;
                                  }}
                                  className={
                                    'tw-outline-none disabled:tw-cursor-not-allowed tw-font-medium tw-border-none tw-leading-none tw-rounded-lg tw-m-0 tw-pl-4 tw-flex-1'
                                  }
                                  disabled={selected[`${item.id}`]?.pickup}
                                  value={
                                    this.state.tempInput[item.id]
                                      ?.custom_value ?? 0
                                  }
                                  onChange={(e) => {
                                    let input = e.target;
                                    input.addEventListener(
                                      'mousewheel',
                                      function () {
                                        this.blur();
                                      },
                                    );
                                    const val = e.target.value;
                                    this.setState((prev) => ({
                                      tempInput: {
                                        ...prev?.tempInput,
                                        [item?.id]: {
                                          ...prev?.tempInput?.[item?.id],
                                          custom_value: toNumber(val),
                                        },
                                      },
                                    }));
                                    this.debouncedUpdateCustomAmount(
                                      item,
                                      toNumber(val),
                                    );
                                  }}
                                  onFocus={(e) => {
                                    document.getElementById(
                                      `edit_input_${item.id}_btn`,
                                    ).style.color = '#9c9c9c';
                                    e.target.select();
                                  }}
                                  onBlur={() => {
                                    document.getElementById(
                                      `edit_input_${item.id}_btn`,
                                    ).style.color = 'white';
                                  }}
                                  defaultValue={
                                    item?.custom_unit == 'absolute' ? 0 : 100
                                  }
                                />

                                {/* Edit button */}
                                <div
                                  className={
                                    'tw-text-white tw-font-medium tw-cursor-pointer tw-p-3 tw-px-5 tw-bg-base-green tw-rounded-r-md tw-w-28 tw-flex tw-items-center tw-justify-center tw-text-[1.4rem]'
                                  }
                                  id={`edit_input_${item.id}_btn`}
                                  onClick={() => {
                                    document.getElementById(
                                      `edit_input_${item.id}_btn`,
                                    ).style.color = '#d6d6d6';
                                    document
                                      .getElementById(`input_${item.id}`)
                                      .focus();
                                    document
                                      .getElementById(`input_${item.id}`)
                                      .select();
                                  }}
                                >
                                  Edit
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Refund Input UI */}
                        </div>
                      )}

                    {/* Card Number Selector for Pinelabs Gift Cards */}
                    {selected?.[`${item.id}`]?.quantity > 0 &&
                      item?.serial_numbers?.length > 0 &&
                      (() => {
                        const maxSelectable =
                          selected?.[`${item.id}`]?.quantity || 0;
                        const cardOptions = (item.serial_numbers || []).map(
                          (c) => {
                            const cardStr = String(c);
                            return {
                              value: cardStr,
                              label: `Card ending in ${cardStr.slice(-4)}`,
                            };
                          },
                        );
                        const currentSelected = (
                          selected?.[`${item.id}`]?.selected_serial_numbers ||
                          []
                        ).map(String);
                        return (
                          <div className='tw-w-full tw-mb-3'>
                            <label className='tw-text-200 tw-font-medium tw-text-grey-700 tw-mb-1 tw-block'>
                              Card Number(s)
                            </label>
                            <InputV1
                              multiple={true}
                              options={cardOptions}
                              selectedValues={currentSelected}
                              placeholder={`Select ${maxSelectable} card number(s)`}
                              isSearchable={true}
                              closeOnSelect={false}
                              inputClassName='!tw-min-h-[3.6rem] !tw-border-grey-300 !tw-rounded-xl'
                              onChange={(nextArr) => {
                                const values = (nextArr || []).map((v) =>
                                  typeof v === 'object'
                                    ? String(v.value)
                                    : String(v),
                                );
                                const capped = values.slice(0, maxSelectable);
                                this.updateSelectedCards(item, capped);
                              }}
                            />
                          </div>
                        );
                      })()}

                    {item?.customisations && item?.customisations?.length ? (
                      <SubItemSelectionView
                        parentItemId={item.id}
                        subItems={item?.customisations}
                        selectSubItems={this.selectSubItems}
                        pickup={selected?.[`${item.id}`]?.pickup}
                        quantity={selected?.[`${item.id}`]?.quantity}
                        selectedSubItems={itemSelectedSubItems}
                        mainItemSelected={
                          selected?.[`${item.id}`]?.quantity &&
                          selected[`${item.id}`].quantity > 0
                        }
                      />
                    ) : null}
                  </div>
                </div>
              </div>

              {/* Bistro Combo Order Items List (only for Bistro Combo orders)*/}
              <BistroComboUI comboComposition={combo_composition} />

              <div className='tw-h-[2px] tw-rounded-full tw-bg-grey-200 tw-mt-6 tw-mb-12' />
            </>
          );
        })}
      </div>
    );
  }
}
